<template lang="pug">
  .home
    .contract
      .contract__title Заключить договор
      .contract__text Пожалуйста, ознакомьтесь с текстом 
        a(href='#') договора-оферты
        |  и 
        a(href='#') лицензионным договором. 
        br
        | Заполните актуальные реквизиты для продажи билетов и приема платежей.
    .tabs
      .tabs__title
        a(href='#' 
          v-for="tab in tabs" 
          :key="tab.name" 
          :class="[{active: currentTab === tab.name}]" 
          @click.prevent="currentTab = tab.name"
        ).tabs__link {{ tab.title }}
      .tabs__content
        component(:is="currentTab").tab
</template>

<script>
import Entity from '@/components/tabs/Entity.vue'
import Indent from '@/components/tabs/Indent.vue'
import Individual from '@/components/tabs/Individual.vue'

export default {
  name: 'home',
  data: function() {
    return {
      currentTab: 'entity',
      tabs: [
        {
          name: 'entity', 
          title: String,
        },
        {
          name: 'indent', 
          title: String
        },
        {
          name: 'individual', 
          title: String
        },
      ]
    }
  },
  components: {
    Entity,
    Indent,
    Individual
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      //Init
      this.resize()
    })
  },
  methods: {
    resize() {
      let windowWidth = document.documentElement.clientWidth;
      const desktop = windowWidth  > 768;
      this.$set(this.tabs[0], 'title', desktop ? 'Юридическое лицо' : 'Юр. лицо');
      this.$set(this.tabs[1], 'title', desktop ? 'Индивидуальный предприниматель' : 'ИП');
      this.$set(this.tabs[2], 'title', desktop ? 'Физическое лицо' : 'Физ. лицо');
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style lang="scss">
.contract{
  background-color: #008cff;
  background-image: linear-gradient(to right, #008cff 0%, #b533eb 100%);
  padding: 40px;
  &__title{
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    line-height: 25px;
    margin-bottom: 20px;
  }
  &__text{
    color: #ffffff;
    font-size: 16px;
    line-height: 25px;
    a{
      color: #fff;
      text-decoration: none;
      border-bottom: 1px solid currentColor;
      &:hover{
        border-bottom-color: transparent;
      }
    }
  }
}

@media (max-width: 768px)  {
  .contract{
    padding: 30px 20px;
    &__title{
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 10px;
    }
    &__text{
      font-size: 15px;
      line-height: 20px;
    }
  }
  .tabs{
    padding: 20px 10px 20px 20px;
  }
}
</style>
